import UAParser, { UAParserInstance } from "ua-parser-js";

const parser: UAParserInstance = new UAParser();

export const device = parser.getDevice();
export const browser = parser.getBrowser();
export const os = parser.getOS();
